/**
 * Native ad slot configurations for GAM (Google Ad Manager)
 */

import type { InjectionKey } from 'vue';

export const NATIVE_AD_SLOTS = {
	SQTV_LIST: {
		slotId: 'native_sqtv_list_buybox',
		adUnitPath: '/21679119891/native_sqtv_list_buybox',
		sizes: ['fluid', [1, 1]] as const,
	},
	BACKDROP: {
		slotId: 'native_backdrop',
		adUnitPath: '/21679119891/native_backdrop',
		sizes: 'fluid' as const,
	},
} as const;

export const nativeAdTargeting = {
	SQTV_LIST: {
		provider_icon: 'https://images.justwatch.com/icon_wide/322151206/s160/appletvplus.jpg',
		tag_2: 'Drama',
		target_poster: 'https://images.justwatch.com/poster/331595100/s166/smoke-2025.jpg',
		target_title: 'Smoke',
		target_backdrop: 'https://images.justwatch.com/backdrop/339550588/s1920/smoke-2025.jpg',
		jw_score: '77%',
		rt_score: '74%',
		imdb_score: '6.7',
	},

	BACKDROP: {
		countdown: 6,
		posterUrl: 'https://images.justwatch.com/poster/331595100/s166/smoke-2025.jpg',
		year: '2025',
		title: 'Smoke',
		icon: 'https://images.justwatch.com/icon/190848813/s100/apple-tv-plus.jpg',
		clickoutUrl:
			'https://tv.apple.com/us/show/smoke/umc.cmc.4lplbt076d3um4tenis7k58e3?itscg=MC_30000&itsct=atvp_brand_omd&mttn3pid=TTD&mttnagencyid=a5e&mttncc=US&mttnsiteid=143238&mttnsubad=05672887&mttnsubplmnt=--',
	},
} as const;

/**
 * Injection key for native ad rendered callback
 * Used by NativeAdSQTVList to notify FreeTrialSwiperOSContainer when ad has rendered
 */
export const NATIVE_AD_RENDERED_KEY: InjectionKey<() => void> = Symbol('nativeAdRendered');
